import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';

export const enviarNotificacao = async(notificacao) => {
  try {
    const httpClient = authenticatedHttpClientFactory();
    await httpClient.post('notificacao', notificacao);
    return true;
  } catch (error) {
    if (error.response.status === 400) return error.response.data.validation.body.message;
    throw error;
  }
};

export const getPaginatedNotificacaoData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`notificacao?${new URLSearchParams(params).toString()}`);
  return response.data;
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
});
